//////////////////////////////////////////////
//! SOUNDMANAGER 
//////////////////////////////////////////////
SoundManager = function(dispatcher) {

	/*---------------------------------------------------
	Static Vars
	--------------------------------------------------*/

	/*---------------------------------------------------
	Vars
	--------------------------------------------------*/
	this.dispatcher = dispatcher;
	/*--------------------------------------------------*/

	this.init();

};

SoundManager.prototype = {


	constructor: SoundManager,
	
	/*---------------------------------------------------
		INITIALIZER
	--------------------------------------------------*/

	init : function() {
		this.initSounds();
		this.bindEvents();
	},
	
	/*---------------------------------------------------
		EVENT HANDLERS 
	--------------------------------------------------*/
	onTabSound : function(){
		if( Math.random() > 0.5 )this.tabSound.play();
		else this.tabSound2.play();
	},
	onVisibility : function( e, data ){
		Howler.mute(data);
	},
	
	onMuteSound : function ( e, data){
		Howler.mute( true );
	},

	onUnMuteSound : function ( e, data ){
		Howler.mute(false);
	},

	onChargeSound : function ( e, data ){
		this.chargeSound.play();
	},
	
	onMuteChargeSound : function ( e, data ){
		this.chargeSound.stop();
	},

	/*---------------------------------------------------
		FUNCTIONS 
	--------------------------------------------------*/
	initSounds : function(){
		this.backgroundSound = new Howl( { src: [settings.sounds.background],
			autoplay : true,
			loop : true,
			volume : 1
		});

		this.tabSound = new Howl( { src: [settings.sounds.tab1],
			autoplay : false,
			loop : false,
			volume : 1
		});

		this.tabSound2 = new Howl( { src: [settings.sounds.tab2],
			autoplay : false,
			loop : false,
			volume : 1
		});
		this.chargeSound = new Howl( { src: [settings.sounds.charge],
			autoplay : false,
			loop : false,
			volume : 1
		});
	},

	bindEvents : function() {
		this.dispatcher.addEventListener( EVENTS.TAB_SOUND, this.onTabSound.bind( this ) ) ;
		this.dispatcher.addEventListener( EVENTS.VISIBILITY_CHANGE, this.onVisibility.bind( this ) ) ;
		this.dispatcher.addEventListener( EVENTS.MUTE_SOUND, this.onMuteSound.bind( this ) ) ;
		this.dispatcher.addEventListener( EVENTS.UNMUTE_SOUND, this.onUnMuteSound.bind( this ) ) ;

		this.dispatcher.addEventListener( EVENTS.CHARGE_SOUND_ON, this.onChargeSound.bind( this ) ) ;
		this.dispatcher.addEventListener( EVENTS.CHARGE_SOUND_OFF, this.onMuteChargeSound.bind( this ) ) ;

	}

};
